<script>
import magnetic from '../components/Magnetic.vue';
import blob from '../components/blob.vue';

export default {
    components: {
        magnetic,
        blob
    },

    data() {
        return {
            sticky: false
        };
    },

    mounted() {
        ScrollTrigger.create({
            trigger: this.$root.$refs.page,
            start: '400px top',
            end: 'bottom bottom',
            onEnter: () => {
                this.sticky = true;
            },
            onLeaveBack: () => {
                this.sticky = false;
            }
        });
    }
};
</script>
